import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export const ServiceDeskCustomerNotificationsNextGenRedirect = ({ match }: RouteContext) => {
	const { projectKey } = match.params;

	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
	return <Redirect to={url} />;
};
